import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../../services/authService";
import styles from "./loginOtp.module.css";
import { useState } from "react";
import { validateEmail, validateMobile } from "../../utils/Validations";
export default function LoginOtp() {
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
 } = useForm({
  defaultValues: { login: "" },
  mode: "onBlur",
});
  const onSubmit = async ({ login }) => {
    try {
      setSending(true);

      const res = await authService.sendLoginOtp(login);
      if (res?.data?.user?.user_role === "admin") {
        toast.error("Admin not allowed to login with OTP. Please use Admin Login.");
        return;
      }
      toast.success("OTP sent successfully");
      navigate("/login/otp/verify", {
        state: { login },
      });
    } catch (err) {

      const message = err?.response?.data?.message;
      if (message === "ADMIN_LOGIN_NOT_ALLOWED") {
        toast.error("Admin not allowed to login with OTP. Please use Admin Login.");
      } else {
        toast.error(message || "Failed to send OTP");
      }
    } finally {
      setSending(false);
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.card}>
          <div className={styles.logo}>
            <Link to="/">
              <img src="/Pharmacy_logo_1.svg" alt="Logo" />
            </Link>
          </div>
          <h4 className={styles.title}>Login with OTP</h4>
          <p className={styles.subtitle}>
            Enter email or phone number :
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.inputGroup}>
              <input
                className={styles.input}
                placeholder="Email or Phone Number"
              {...register("login", {
  required: "Email or phone number is required",
  validate: (value) => {
    const input = value?.trim() || "";

    const emailResult = validateEmail(input);
    const mobileResult = validateMobile(input);

    if (emailResult === true || mobileResult === true) {
      return true;
    }

    return "Please enter a valid email address or mobile number";
  },
})}
              />
              {errors.login && (
                <p className={styles.error}>{errors.login.message}</p>
              )}
            </div>
            <button
              className={styles.button}
              disabled={sending} 
                style={{ backgroundColor: "#1e939b", color: "#fff", border: "none" }}
            >
              {sending ? "Sending OTP..." : "Send OTP"}
            </button>
          </form>
          <div className={styles.textCenter}>
            <Link to="/login" className={styles.link}>
              Back to Password Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}